import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { CmAuthService, TWO_STEP_STORE } from '../services';

@Directive()
export abstract class HiddenFormPost implements AfterViewInit {
	@Input() path: string;
	@Input() targetWindow: '_blank' | '_self' | '_parent' | '_top';
	protected basePath: string;

	constructor(private el: ElementRef, private auth: CmAuthService, private renderer: Renderer2) {}

	ngAfterViewInit() {
		this.renderer.listen(this.el.nativeElement, 'click', () => this.handleClick());
	}

	private handleClick() {
		try {
			const url = this.basePath ? this.basePath + '/' + this.path : this.path;
			const form: HTMLFormElement = this.renderer.createElement('form');
			this.renderer.setAttribute(form, 'action', url);
			this.renderer.setAttribute(form, 'method', 'post');
			this.renderer.setAttribute(form, 'hidden', 'true');
			this.renderer.setAttribute(form, 'target', this.targetWindow);
			const inp = this.renderer.createElement('input');
			this.renderer.setAttribute(inp, 'type', 'text');
			this.renderer.setAttribute(inp, 'name', 'Authorization');
			this.renderer.setAttribute(inp, 'value', `Bearer ${this.auth.getAuthToken()}`);
			if (this.auth.getTwoStepToken()) {
				const inp2 = this.renderer.createElement('input');
				this.renderer.setAttribute(inp2, 'type', 'text');
				this.renderer.setAttribute(inp2, 'name', TWO_STEP_STORE);
				this.renderer.setAttribute(inp2, 'value', `${this.auth.getTwoStepToken()}`);
				this.renderer.appendChild(form, inp2);
			}
			this.renderer.appendChild(form, inp);
			const body = this.renderer.selectRootElement('body', true);
			this.renderer.appendChild(body, form);
			form.submit();
			// This is commented out because it is the only thing I can think of that might be causing
			// the issue we keep getting in the error logger that we cannot reproduce.
			// We are leaving this here so we can add it back in if we still get the error in the error logger.
			// this.renderer.removeChild(body, form);
		} catch (err) {
			throw new Error(
				`Problem in SSO click handler ${JSON.stringify(
					err
				)} | Auth token ${!!this.auth.getAuthToken()} | 2 step ${!!this.auth.getTwoStepToken()}`
			);
		}
	}
}
